/*
 * De USP-carousels (.usp-bar__track onder de hero op de homepage en de
 * .wt-keys__list van de "Het verschil dat je voelt en ziet"-kaart, op de
 * homepage features_banner_BjKeie en op de collectiepagina
 * features_banner_NUGb3X) swipen op mobiel al via plain CSS scroll-snap (see
 * section-usp-bar.css / lumedi-safe-space.css) - no JS
 * needed for that. This file only adds autoplay on top: every few seconds the
 * container scrolls to the next item, same as the theme's own Swiper
 * autoplay (see the "icon_layout_mobile: slider" option in
 * features-banner.liquid), without swapping the markup/styling for it.
 *
 * Autoplay pauses on manual interaction and while the carousel is out of
 * view, and is skipped entirely for prefers-reduced-motion.
 */
(function () {
  var AUTOPLAY_DELAY = 5000;
  var RESUME_DELAY = 5000;

  function setupAutoCarousel(container) {
    if (!container || container.__lumediAutoplay) return;
    container.__lumediAutoplay = true;

    var reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (reducedMotion) return;

    var timer = null;
    var resumeTimeout = null;

    function isScrollable() {
      return container.scrollWidth > container.clientWidth + 1;
    }

    function advance() {
      if (!isScrollable()) return;
      var atEnd =
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth - 1;
      var nextLeft = atEnd ? 0 : container.scrollLeft + container.clientWidth;
      container.scrollTo({ left: nextLeft, behavior: "smooth" });
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(advance, AUTOPLAY_DELAY);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function pauseThenResume() {
      stop();
      window.clearTimeout(resumeTimeout);
      resumeTimeout = window.setTimeout(start, RESUME_DELAY);
    }

    container.addEventListener("pointerdown", pauseThenResume, {
      passive: true,
    });
    container.addEventListener("wheel", pauseThenResume, { passive: true });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
          } else {
            stop();
          }
        });
      },
      { threshold: 0.5 },
    );
    observer.observe(container);
  }

  function init() {
    document
      .querySelectorAll(
        [
          '[id$="__usp_bar_eixYwi"] .usp-bar__track',
          '[id$="__features_banner_BjKeie"] .wt-keys__list',
          '[id$="__features_banner_NUGb3X"] .wt-keys__list',
        ].join(", "),
      )
      .forEach(setupAutoCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
